export default {
  EDIT_ITEM_SET_ACTIVE_VIEW: 'EDIT_ITEM_SET_ACTIVE_VIEW',
  EDIT_ITEM_SET_STAGES: 'EDIT_ITEM_SET_STAGES',
  EDIT_ITEM_ADD_STAGE: 'EDIT_ITEM_ADD_STAGE',
  EDIT_ITEM_DELETE_STAGE: 'EDIT_ITEM_DELETE_STAGE',
  EDIT_ITEM_SET_FORM_DATA: 'EDIT_ITEM_SET_FORM_DATA',
  EDIT_ITEM_SET_STAGE_FORM_DATA: 'EDIT_ITEM_SET_STAGE_FORM_DATA',
  EDIT_ITEM_SET_HAS_VARIANTS: 'EDIT_ITEM_SET_HAS_VARIANTS',
  EDIT_ITEM_SET_VARIANTS: 'EDIT_ITEM_SET_VARIANTS',
  EDIT_ITEM_SET_SUBTOTAL: 'EDIT_ITEM_SET_SUBTOTAL',
  EDIT_ITEM_SET_VARIANTS_TOTAL: 'EDIT_ITEM_SET_VARIANTS_TOTAL',
  EDIT_ITEM_SET_CHARGES_TOTAL: 'EDIT_ITEM_SET_CHARGES_TOTAL',
  EDIT_ITEM_SET_DECORATIONS_TOTAL: 'EDIT_ITEM_SET_DECORATIONS_TOTAL',
  EDIT_ITEM_SET_CHARGES: 'EDIT_ITEM_SET_CHARGES',
  EDIT_ITEM_SET_DECORATION: 'EDIT_ITEM_SET_DECORATION',
  EDIT_ITEM_SET_IMAGES: 'EDIT_ITEM_SET_IMAGES',
  EDIT_ITEM_SET_VARIANT_SCHEMA: 'EDIT_ITEM_SET_VARIANT_SCHEMA',
  EDIT_ITEM_RESET: 'EDIT_ITEM_RESET',
};
